import request from "./http";

// 添加系统信息
export const addSystemData = data => {
    return request({
        url: '/auth/system/addSystemInfo',
        method: 'post',
        data

    })
}
// 修改系统信息
export const updateSystemData = data => {
    return request({
        url: '/auth/system/modifySystemInfo',
        method: 'post',
        data
    })
}
// 删除系统信息
export const deleteSystemData = data  => {
    return request({
        url: '/auth/system/deleteSystemInfo?companyId='+data.companyId+"&userCode="+data.userCode,
        method: 'get',
    })
}
// 系统信息查询
export const getSystemData = data => {
    return request({
        url: '/auth/system/pageFindSystemInfo',
        method: 'post',
        data
    })
}
